import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { APP_ASSESSMENT_GAUGE_PALETTE_MAX_5, DetailsChartsDto } from '@pt/pt-models';
import { AppAssessmentsService } from '@pt/api-client';
import { ActionsSubject, Store } from '@ngrx/store';
import { AppAssessmentDetails } from '@primatoo-ms-organization';
import {  StatsChartBuilder } from '../../utils/stats-chart-builder';
import * as NgrxWidgetActions from '../../documents/store/actions/widget.actions';
import { TranslateService } from '@ngx-translate/core';
import { ofType } from '@ngrx/effects';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pt-app-result',
  template: `
    <div class="mb-2 mt-4">
      <pt-details-chart
        [showReloadButton]="requireReload && !autoReload"
        [title]="'LABELS.APP_ASSESSMENTS' | translate"
        [gaugeColor]='gaugeColor'
        [charts]='charts'
        (reload)="reloadResult()">
      </pt-details-chart>
    </div>
  `
})
export class AppResultComponent implements OnChanges, OnInit {
  @Input() docId: number;
  @Input() requireReload: boolean;
  @Input() autoReload = false;
  public gaugeColor = APP_ASSESSMENT_GAUGE_PALETTE_MAX_5;
  public charts: DetailsChartsDto[];


  constructor(private service: AppAssessmentsService,
              private actionsSubject: ActionsSubject,
              private store: Store, private i18n: TranslateService) {
  }

  ngOnInit(): void {
    this.actionsSubject.pipe(
      ofType(
        NgrxWidgetActions.forceReloadedResult
      ),
      untilDestroyed(this)
    ).subscribe(() => {
      this.reloadResult();
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.docId) {
      this.reloadResult();
    }

    if (changes.requireReload) {
      if (this.requireReload && this.autoReload) {
        this.reloadResult();
      }
    }
  }

  private alignWidget(evaluation: AppAssessmentDetails) {
    this.charts = StatsChartBuilder.buildAppAssessmentStats(evaluation, this.i18n);
  }

  public reloadResult() {
    this.service.getRefreshResult(this.docId).subscribe(() => {
      this.service?.getDetails(this.docId).subscribe((result: AppAssessmentDetails) => {
        this.alignWidget(result);
        this.store.dispatch(NgrxWidgetActions.reloadedResult());
      }, () => {
        this.store.dispatch(NgrxWidgetActions.reloadedResult());
      });
    }, () => {
      this.service?.getDetails(this.docId).subscribe((result: AppAssessmentDetails) => {
        this.alignWidget(result);
        this.store.dispatch(NgrxWidgetActions.reloadedResult());
      }, () => {
        this.store.dispatch(NgrxWidgetActions.reloadedResult());
      });
    })
  }
}
